import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import Dropzone from "@mostrans/web-components/components/base/Dropzone";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import Pagination from "@mostrans/web-components/components/base/Pagination";
import Select from "@mostrans/web-components/components/base/Select";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  Alert,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Fab,
  FormControlLabel,
  Grid,
  Icon,
  Link,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import ReactTooltip from "react-tooltip";
import { useRecoilState, useSetRecoilState } from "recoil";
import TemplateHasilMCU from "../../../DOCX/medcheck-result.docx";
import TemplatePangantarMCU from "../../../DOCX/surat-pemeriksaan.docx";
import {
  AssignInterviewDateCandidate,
  AssignMedicalCheckupDateCandidate,
  AssignPsikotestDateCandidate,
  AssignTechnicalTestCandidate,
  BlacklistCandidate,
  UpdateStatusOpportunityCandidate,
} from "../../../GQL/mutations";
import { valueUseRef } from "../../../shared/atoms/getValueInputAtoms";
import { uploadMCUDoc, uploadTestDoc } from "../../../shared/firebaseServices";
import { generateDocx } from "../../../shared/generateDocx";
import { globalLoadingScreenAtom } from "../../../shared/globalStates";
import {
  fileValidation,
  generateFileName,
  getDataForHasilMCU,
  getDataForPengantarMCU,
  toastError,
  toastSuccess,
} from "../../../shared/helpers";
import {
  useGetMasterClinic,
  useGetMasterLokasiInterview,
  useGetStatusAdmin,
} from "../../../shared/hooks/useGetMasterData";
import { ButtonExportCandidate } from "./ButtonExportCandidate";
import ModalCandidate from "./modals/ModalCandidate";

function CandidatesByStatus(props) {
  const {
    dataCandidates,
    opportunityID,
    fetchCandidateOpportunityByID,
    dataOpportunity,
  } = props;
  const { selectedCandidate, setSelectedCandidate } = props;
  const { selectedAllCandidate, setSelectedAllCandidate } = props;
  const [listStatusAdmin] = useGetStatusAdmin();
  // const [ConfUpdateCandidateStatus] = useConfirmationModal();
  const [selectedPsikotesDate, setSelectedPsikotestDate] = useState(null);
  const [updateModal, setUpdateModal] = useState(false);
  const [newStatusCandidate, setNewStatusCandidate] = useState();
  const [labelStatus, setLabelStatus] = useState();
  const [interviewDate, setInterviewDate] = useState();
  const [testDate, setTestDate] = useState();
  const [mcuDate, setMcuDate] = useState();
  const [mcuLocation, setMcuLocation] = useState();
  const client = useApolloClient();
  const [psikotestTime, setPsikotestTime] = useState();
  const [interviewTime, setInterviewTime] = useState();
  const [mcuTime, setMcuTime] = useState();
  const [testTime, setTestTime] = useState();
  const [visibleBlacklistReason, setVisibleBlackListReason] = useState(false);
  const [valueBlacklistReason, setValueBlacklistReason] = useState();
  const [fileFormat, setFileFormat] = useState(true);
  const [fileUrl, setFileUrl] = useState();
  const [linkDrive, setLinkDrive] = useState();
  const [uploadFile, setUploadFile] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tahapPsikotestCfit, setTahapPsikotestCfit] = useState(true);
  const [tahapPsikotestPapikostik, setTahapPsikotestPapikostik] =
    useState(false);
  const [intvIsOnline, setIntvIsOnline] = useState(true);
  const [listMasterLokasiInterview] = useGetMasterLokasiInterview();
  const [listMasterClinic] = useGetMasterClinic();
  const [linkInterview, setLinkInterview] = useState("");
  const [locationInterview, setLocationInterview] = useState("");
  const [refBox, setBoxUseRef] = useRecoilState(valueUseRef);
  // const userData = useRecoilValue(userDataSelector);
  const [checkedAll, setCheckedAll] = useState(false);
  const setIsLoading = useSetRecoilState(globalLoadingScreenAtom);

  const optionsLokasiInterview = listMasterLokasiInterview.map(function (
    lokasiIntv
  ) {
    return {
      value: lokasiIntv.nama.concat(",", lokasiIntv.alamat),
      label: lokasiIntv.nama,
    };
  });

  const optionsLokasiMCU = listMasterClinic.map(function (clinic) {
    return {
      value: clinic.clinic_name.concat(
        "-",
        clinic.clinic_address,
        "-",
        clinic?.clinic_email
      ),
      label: clinic.clinic_name.concat(" ", clinic.clinic_branch),
    };
  });

  const handleFile = async (file) => {
    if (!fileValidation(file.name)) {
      return toastError("NOK: file format not supported");
    }
    setUploadFile(file.name);

    const fileName = generateFileName("technical_test-", file.name);

    try {
      setIsLoading(true);
      const url_file = await uploadTestDoc(file, fileName);
      setFileUrl(url_file);
    } catch (error) {
      toastError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClearValueOnState = () => {
    setSelectedCandidate([]);
    setSelectedPsikotestDate("");
    setPsikotestTime("");
    setInterviewDate("");
    setInterviewTime("");
    setMcuDate("");
    setMcuTime("");
    setMcuLocation("");
    setValueBlacklistReason("");
    setLinkInterview("");
    setLocationInterview("");
    setTestDate("");
    setTestTime("");
    setFileFormat("");
    setUploadFile([]);
    setFileUrl("")
    setLinkDrive("");
  };

  const handleSelectedCandidate = (event, value) => {
    let updateSelected = [...selectedCandidate];
    if (event.target.checked) {
      updateSelected = [...selectedCandidate, value];
    } else {
      updateSelected.splice(selectedCandidate.indexOf(value), 1);
    }
    setSelectedCandidate(updateSelected);

    if (updateSelected.length === dataCandidates.length) {
      setCheckedAll(true);
    } else {
      setCheckedAll(false);
    }
  };

  const handleSelectAllCandidate = (event) => {
    let updateSelectedAll = [];
    if (event.target.checked) {
      updateSelectedAll = dataCandidates
        .slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage)
        .map((candidate) => candidate);
      setCheckedAll(true);
    } else {
      updateSelectedAll = [];
      setCheckedAll(false);
    }
    setSelectedAllCandidate(updateSelectedAll);
    setSelectedCandidate(updateSelectedAll);
  };

  const optionStatusAdmin = listStatusAdmin.map(function (status) {
    return { label: status.status, value: status.id };
  });

  const handleUpdateModalClose = () => {
    setUpdateModal(false);
    setFileFormat("");
    setUploadFile([]);
  };

  const handleSelectedStatus = async (e) => {
    setVisibleBlackListReason(false);
    setNewStatusCandidate(e.value);
    setLabelStatus(e.label);
    setUpdateModal(true);
  };

  const handleSelectedCfit = (event) => {
    if (event.target.checked) {
      setTahapPsikotestCfit(true);
    } else {
      setTahapPsikotestCfit(false);
    }
  };

  const handleSelectedPapikostik = (event) => {
    if (event.target.checked) {
      setTahapPsikotestPapikostik(true);
    } else {
      setTahapPsikotestPapikostik(false);
    }
  };

  const handleSelectedIntvIsOnline = (value) => {
    value === "true" ? setIntvIsOnline(true) : setIntvIsOnline(false);
  };

  const handleSelectedFormat = (value) => {
    value === "true" ? setFileFormat(true) : setFileFormat(false);
  };

  const submitUpdateStatusCandidate = async () => {
    const paramUpdate = selectedCandidate.map(function (candidate) {
      return {
        opportunity_id: parseInt(opportunityID),
        opportunity_title: dataOpportunity.title,
        candidate_id: parseInt(candidate.id),
        status_hr_id: newStatusCandidate,
        candidate_email: candidate.email,
        full_name: candidate.full_name,
        hp: candidate.phone_number,
      };
    });

    try {
      const responUpdate = await UpdateStatusOpportunityCandidate(
        client,
        paramUpdate
      );

      if (responUpdate.data.updateStatusOpportunityCandidate.errMsg === "OK") {
        toastSuccess("Candidate Updated.");
        fetchCandidateOpportunityByID();
        handleClearValueOnState();
        setUpdateModal(false);
        setCheckedAll();
      } else {
        toastError(
          "Candidate Update Failed :",
          responUpdate.data.updateStatusOpportunityCandidate.errMsg
        );
      }
    } catch (error) {
      alert(error);
    }
  };

  const submitAssignPsikotest = async () => {
    if (!selectedPsikotesDate && !psikotestTime) {
      return toastError("Tentukan Jadwal Psikotest");
    }
    if (selectedPsikotesDate < thisIsToday) {
      return toastError("Tanggal Psikotest Tidak Valid");
    }
    if (selectedPsikotesDate === thisIsToday && psikotestTime < isGetHourNow) {
      return toastError("Jam Psikotest Tidak Valid");
    }

    if (tahapPsikotestCfit === false && tahapPsikotestPapikostik === false) {
      return toastError("Tentukan tahap Psikotest Terlebih Dahulu.");
    }

    if (intvIsOnline === true) {
      if (!linkInterview) {
        return toastError("Link Psikotest Belum diisi.");
      }
    } else {
      if (!locationInterview) {
        return toastError("Lokasi Psikotest Belum diisi.");
      }
    }

    const paramAssignPsikotest = selectedCandidate.map(function (psikotest) {
      return {
        opportunity_id: parseInt(opportunityID),
        candidate_id: parseInt(psikotest.id),
        candidate_email: psikotest.email,
        psikotest_date: selectedPsikotesDate.concat(" ", psikotestTime),
        full_name: psikotest.full_name,
        hp: psikotest.phone_number,
        mostest1: psikotest.mostest1 === false ? tahapPsikotestCfit : true,
        mostest2:
          psikotest.mostest2 === false ? tahapPsikotestPapikostik : true,
        is_psikotes_online: intvIsOnline,
        psikotes_location:
          intvIsOnline === true ? linkInterview : locationInterview,
        pic_name: "Mostrans HR Departement",
        pic_phone: "+6287784355202",
      };
    });

    try {
      const assignRespon = await AssignPsikotestDateCandidate(
        client,
        paramAssignPsikotest
      );

      if (assignRespon.data.assignPsikotestDateCandidate.errMsg === "OK") {
        toastSuccess("Assign Success");
        fetchCandidateOpportunityByID();
        handleClearValueOnState();
        setUpdateModal(false);
      } else {
        toastError(
          "Assign Failed : ",
          assignRespon.data.assignPsikotestDateCandidate.errMsg
        );
      }
    } catch (error) {
      alert(error);
    }
  };

  const submitAssignInterviewCandidate = async () => {
    if (!interviewDate && !interviewTime) {
      return toastError("Tentukan Jadwal Interview");
    }
    if (interviewDate < thisIsToday) {
      return toastError("Tanggal Interview Tidak Valid");
    }

    if (interviewDate === thisIsToday && interviewTime < isGetHourNow) {
      return toastError("Jam Interview Tidak Valid");
    }

    if (intvIsOnline === true) {
      if (!linkInterview) {
        return toastError("Link Interview Belum diisi.");
      }
    } else {
      if (!locationInterview) {
        return toastError("Lokasi Interview Belum diisi.");
      }
    }

    const paramAssignInterview = selectedCandidate.map(function (candidate) {
      return {
        opportunity_id: parseInt(opportunityID),
        candidate_id: parseInt(candidate.id),
        candidate_email: candidate.email,
        status_id: newStatusCandidate,
        interview_date: interviewDate.concat(" ", interviewTime),
        full_name: candidate.full_name,
        hp: candidate.phone_number,
        is_interview_online: intvIsOnline,
        interview_location:
          intvIsOnline === true ? linkInterview : locationInterview,
        pic_name: "Mostrans HR Departement",
        pic_phone: "+6287784355202",
      };
    });

    try {
      const assignRespon = await AssignInterviewDateCandidate(
        client,
        paramAssignInterview
      );

      if (assignRespon.data.assignInterviewDateCandidate.errMsg === "OK") {
        toastSuccess("Interview Assigned");
        fetchCandidateOpportunityByID();
        handleClearValueOnState();
        setUpdateModal(false);
      } else {
        toastError(assignRespon.data.assignInterviewDateCandidate.errMsg);
      }
    } catch (error) {
      alert(error);
    }
  };

  let today = new Date();
  let thisIsToday = today.toISOString().split("T")[0];
  let increaseMinute = today.getMinutes() - 5;
  let isGetHourNow = "0" + today.getHours() + ":" + increaseMinute;

  const submitAssignTechnicalTest = async () => {
    if (!testDate || !testTime) {
      return toastError("Tentukan Jadwal Pengumpulan");
    }
    if (testDate < thisIsToday) {
      return toastError("Tanggal Pengumpulan Tidak Valid");
    }
    if (testDate === thisIsToday && testTime < isGetHourNow) {
      return toastError("Jam Pengumpulan Tidak Valid");
    }
    if (fileFormat === true) {
      if (uploadFile.length === 0) {
        return toastError("File belum diisi");
      }
    } else {
      if (!linkDrive) {
        return toastError("Link Drive belum diisi");
      }
    }

    const paramAssignTechnicalTest = selectedCandidate.map((candidate) => {
      return {
        opportunity_id: parseInt(opportunityID),
        candidate_id: /* 10048 */ parseInt(candidate.id),
        attachment_technical_test: !fileUrl ? linkDrive : fileUrl,
        technical_test_due_date: testDate.concat(" ", testTime),
        job_title: dataOpportunity.title,
        is_send_notif: true,
      };
    });

    try {
      const assignRespon = await AssignTechnicalTestCandidate(
        client,
        paramAssignTechnicalTest
      );

      if (assignRespon.data.assignTechnicalTestCandidate.errMsg === "OK") {
        toastSuccess("Technical Test Assigned");
        fetchCandidateOpportunityByID();
        handleClearValueOnState();
        setUpdateModal(false);
      } else {
        toastError(assignRespon.data.assignTechnicalTestCandidate.errMsg);
      }
    } catch (error) {
      alert(error);
    }
  };

  const submitAssignMCU = async () => {
    if (selectedCandidate.length > 1) {
      return toastError("Assign MCU Hanya diperbolehkan 1 kandidat.");
    }
    if (!mcuDate && !mcuTime) {
      return toastError("Tentukan Jadwal MCU");
    }
    if (!mcuLocation) {
      return toastError("Tentukan Lokasi MCU");
    }
    if (mcuDate < thisIsToday) {
      return toastError("Tanggal MCU Tidak Valid");
    }
    if (mcuDate === thisIsToday && mcuTime < isGetHourNow) {
      return toastError("Jam MCU Tidak Valid");
    }

    const dataforTemplate = selectedCandidate.map(function (candidate) {
      let dob = new Date(candidate.birth_date);
      //calculate month difference from current date in time
      let month_diff = Date.now() - dob.getTime();
      //convert the calculated difference in date format
      let age_dt = new Date(month_diff);
      //extract year from date
      let year = age_dt.getUTCFullYear();
      //now calculate the age of the user
      let age = Math.abs(year - 1970);
      return {
        datacandidatename: candidate.full_name,
        datausiacandidate: age,
        datajkcandidate: candidate.gender === "M" ? "Laki-laki" : "Perempuan",
        datatempatlahir: candidate.birth_location,
        datatanggallahir: candidate.birth_date.split(",")[0],
        datajabatan: dataOpportunity.title,
        tglperiksa: moment(mcuDate.concat(" ", mcuTime)).format("DD MMMM YYYY"),
      };
    });

    try {
      setIsLoading(true);
      const bloobPengantarMcu = await generateDocx(
        TemplatePangantarMCU,
        getDataForPengantarMCU(dataforTemplate)
      );

      const bloobHasilMcu = await generateDocx(
        TemplateHasilMCU,
        getDataForHasilMCU(dataforTemplate)
      );

      const urlPengantarMcu = await uploadMCUDoc(
        bloobPengantarMcu,
        `DOCPNGTRMCU-${selectedCandidate[0].short_name}`,
        "MCUPENGANTAR"
      );

      const urlResultMcu = await uploadMCUDoc(
        bloobHasilMcu,
        `DOCRESMCU-${selectedCandidate[0].short_name}`,
        "MCURESULT"
      );

      const paramAssignMCU = selectedCandidate.map(function (candidate) {
        return {
          opportunity_id: parseInt(opportunityID),
          candidate_id: parseInt(candidate.id),
          candidate_email: candidate.email,
          medcheck_location: mcuLocation,
          medcheck_date: mcuDate.concat(" ", mcuTime),
          full_name: candidate.full_name,
          doc_pengantar_mcu: urlPengantarMcu,
          doc_hasil_mcu: urlResultMcu,
          hp: candidate.phone_number,
        };
      });

      const assignRespon = await AssignMedicalCheckupDateCandidate(
        client,
        paramAssignMCU
      );

      if (assignRespon.data.assignMedicalCheckupDateCandidate.errMsg === "OK") {
        toastSuccess("MCU Assigned");
        fetchCandidateOpportunityByID();
        handleClearValueOnState();
        setUpdateModal(false);
      } else {
        toastError(
          "Assign Failed : ",
          assignRespon.data.assignMedicalCheckupDateCandidate.errMsg
        );
      }
    } catch (error) {
      alert(error);
    } finally {
      setIsLoading(false);
    }
  };

  const submitBlackList = async () => {
    const paramBlackList = selectedCandidate.map(function (candidate) {
      return {
        candidate_id: parseInt(candidate.id),
        blacklist_reason: valueBlacklistReason,
      };
    });

    try {
      await BlacklistCandidate(client, paramBlackList);
    } catch (error) {
      alert(error);
    }
  };

  const submitBlacklistMerge = () => {
    submitBlackList();
    submitUpdateStatusCandidate();
  };
  const handleCheckBlacklist = (e) => {
    if (e) {
      setVisibleBlackListReason(true);
    } else {
      setVisibleBlackListReason(false);
    }
  };

  const goToTop = () => {
    const coba = document.getElementsByTagName("h4");
    coba[0].scrollIntoView();
    // refBox?.scrollTo({ top: 0, behavior: "smooth" });
    // window.focus();
    // window.scrollTo(0, 0);
    // console.log("refbox", refBox.scrollTo());
    // window.scrollTo({
    //   top: 0,
    //   left: 0,
    //   behavior: "smooth",
    // });
  };

  const changePage = (page) => {
    setCurrentPage(page);
    goToTop();
  };

  // const [scrollY, setScrollY] = useState(0);
  // useEffect(() => {
  //   console.log("scrolly", scrollY);
  //   const handleScroll = () => {
  //     setScrollY(window.scrollY);
  //   };
  //   handleScroll();

  //   window.addEventListener("scroll", handleScroll);
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  const [showComponent, setShowComponent] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        // Adjust this value based on when you want to show the component
        setShowComponent(true);
      } else {
        setShowComponent(false);
      }
    };

    console.log("showcomponent", showComponent);

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // const onTestPdf = async () => {
  //   const dataforTemplate = selectedCandidate.map(function (candidate) {
  //     let dob = new Date(candidate.birth_date)
  //     let month_diff = Date.now() - dob.getTime();
  //     let age_dt = new Date(month_diff);
  //     let year = age_dt.getUTCFullYear();
  //     let age = Math.abs(year - 1970);
  //     return {
  //       datacandidatename: candidate.full_name,
  //       datausiacandidate: age,
  //       datajkcandidate: candidate.gender === "M" ? "Laki-laki" : "Perempuan",
  //       datatempatlahir: candidate.birth_location,
  //       datatanggallahir: candidate.birth_date.split(",")[0],
  //       datajabatan: dataOpportunity.title,
  //     };
  //   });

  //   const bloobPengantarMcu = await generateDocx(
  //     TemplatePangantarMCU,
  //     getDataForPengantarMCU(dataforTemplate)
  //   );

  //   console.log("blob word", bloobPengantarMcu)

  //   const pdfBlob = await convertWordToPDF(bloobPengantarMcu)

  //   // const urlPengantarMcu = await uploadMCUDoc(
  //   //   pdfBlob,
  //   //   `DOCPNGTRMCU`,
  //   //   "MCUPENGANTAR"
  //   // )

  // }

  return (
    <React.Fragment>
      <Grid item xs={12} md={4} lg={9}>
        <div
          className="form-row"
          style={{ marginTop: 5, marginBottom: 15 }}
          ref={(e) => setBoxUseRef((p) => (p ? p : e))}
        >
          <div className="col-12 mb-1" align="right">
            <ButtonExportCandidate
              id={opportunityID}
              dataCandidates={dataCandidates}
            />
          </div>
          <div className="col-md-6">
            {selectedCandidate.length || selectedAllCandidate.length > 0 ? (
              <Select
                styles={{ zIndex: "9999" }}
                // menuPosition="fixed"
                options={optionStatusAdmin}
                onChange={(e) => handleSelectedStatus(e)}
              />
            ) : null}
          </div>
        </div>
        {dataCandidates.length === 0 ? null : (
          <div>
            <label>
              <Checkbox
                value={dataCandidates}
                checked={checkedAll}
                onChange={(e) => {
                  handleSelectAllCandidate(e, dataCandidates);
                }}
              />{" "}
              <span style={{ fontSize: "small" }}>
                Select All on the current page
              </span>
            </label>
          </div>
        )}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          {dataCandidates
            .slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage)
            .map((candidate, index) => (
              <React.Fragment>
                <Grid item xs={12} md={4} lg={6} key={candidate.id}>
                  <Card variant="outlined" sx={{ maxWidth: 600 }}>
                    <CardHeader
                      action={
                        <Checkbox
                          checked={
                            selectedCandidate.findIndex(
                              (item) => item.id === candidate.id
                            ) > -1
                          }
                          value={candidate}
                          onChange={(e) =>
                            handleSelectedCandidate(e, candidate)
                          }
                        />
                      }
                      title={
                        <span>
                          <Typography
                            component="h5"
                            variant="h5"
                            color="primary"
                            gutterBottom
                            sx={{ fontWeight: 500 }}
                          >
                            {candidate.full_name}
                          </Typography>
                          {candidate.is_blacklist === true ? (
                            <Alert
                              data-tip={candidate.blacklist_reason}
                              severity="error"
                            >
                              Blacklisted
                            </Alert>
                          ) : null}
                          <ReactTooltip />
                        </span>
                      }
                      subheader={
                        <Typography>
                          Email : {candidate.email} |
                          <Link
                            href={
                              "https://wa.me/" +
                              candidate.phone_number.replace(
                                candidate.phone_number.charAt(0),
                                "62"
                              ) +
                              "?text=Halo%20Bapak%2FIbu%0ASalam%20kenal%2Ckami%20dari%20team%20Talent%20Acquisition%20Mostrans%0ASebelumnya%20terima%20kasih%20telah%20tertarik%20untuk%20menjadi%20bagian%20di%20Mostrans%2C%20mohon%20dibantu%0Auntuk%20menginformasikan%20sosial%20media%20aktif%20yang%20bapak%2Fibu%20punya%2C%20dikarenakan%20untuk%20saat%0Aini%20kami%20sedang%20memperluas%20relasi%20di%20sosial%20media%20kami.%0ATerima%20kasih."
                            }
                            target="_blank"
                            underline="hover"
                            color="black"
                          >
                            Phone: {candidate.phone_number}
                            <OpenInNewIcon />
                          </Link>
                        </Typography>
                      }
                    />
                    <CardContent>
                      {candidate?.Experiences ? (
                        <React.Fragment>
                          <Typography sx={{ mb: 1 }}>
                            {
                              Object.values(candidate?.Experiences).pop()
                                .job_position
                            }
                            &nbsp; at &nbsp;
                            <span style={{ fontWeight: 500 }}>
                              {
                                Object.values(candidate?.Experiences).pop()
                                  .company
                              }
                            </span>
                          </Typography>
                          <Typography sx={{ mt: -1 }} color="GrayText">
                            (
                            {candidate?.Experiences
                              ? Object.values(candidate?.Experiences)
                                .pop()
                                .start_date?.split(",")[0]
                              : null}{" "}
                            -{" "}
                            {candidate?.Experiences
                              ? Object.values(candidate.Experiences).pop()
                                .is_current === true
                                ? "Now"
                                : Object.values(candidate?.Experiences)
                                  .pop()
                                  .end_date?.split(",")[0]
                              : null}
                            )
                          </Typography>
                        </React.Fragment>
                      ) : null}
                      <div className="form-row mt-1">
                        <div className="col-md-5">
                          <Typography sx={{ fontWeight: 500 }}>
                            PreAssesment{" "}
                            {candidate?.is_pre_assessment_done === true ? (
                              <Icon sx={{ color: "#0A8C4A" }}>task_alt</Icon>
                            ) : (
                              <Icon sx={{ color: "red" }}>cancel</Icon>
                            )}
                          </Typography>
                        </div>
                        <div className="col-md-4">
                          <Typography sx={{ fontWeight: 500 }}>
                            Papikostik{" "}
                            {candidate?.is_papikostik_done === true ? (
                              <Icon sx={{ color: "#0A8C4A" }}>task_alt</Icon>
                            ) : (
                              <Icon sx={{ color: "red" }}>cancel</Icon>
                            )}
                          </Typography>
                        </div>
                        <div className="col-md-3">
                          <Typography sx={{ fontWeight: 500 }}>
                            CFIT
                            {candidate?.cfit_score ? (
                              <Icon sx={{ color: "#0A8C4A" }}>task_alt</Icon>
                            ) : (
                              <Icon
                                className="material-symbols-outlined"
                                sx={{ color: "red" }}
                              >
                                cancel
                              </Icon>
                            )}
                          </Typography>
                        </div>
                      </div>
                    </CardContent>
                    <CardActions>
                      <ModalCandidate
                        candidateID={candidate.id}
                        opportunityID={opportunityID}
                        fetchCandidateOpportunityByID={
                          fetchCandidateOpportunityByID
                        }
                      />
                    </CardActions>
                  </Card>
                </Grid>
              </React.Fragment>
            ))}
        </Grid>
        {dataCandidates?.length ? (
          <Pagination
            totalData={dataCandidates?.length}
            currentPage={currentPage}
            onPageChange={({ page }) => changePage(page)}
            rowsPerPage={rowsPerPage}
            // rowsPerPageOptions={[10, 30, 50, 60]}
            onRowsPerPageChange={setRowsPerPage}
            showFirstLastButton={true}
            showResult={true}
            // showRowsPerPageOptions={true}
            showPageNumber={true}
          />
        ) : null}

        {dataCandidates.length === 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              justifyItems: "center",
              height: "100vh",
              marginTop: 50,
            }}
          >
            <p>No Data :(</p>
          </div>
        ) : null}
      </Grid>

      <ToastContainer />
      {/* <ConfUpdateCandidateStatus /> */}

      {/* {showComponent && ( */}
      <div style={{ position: "fixed", right: 30, bottom: 30 }}>
        <Fab color="primary" onClick={goToTop}>
          <Icon>arrow_upward</Icon>
        </Fab>
      </div>
      {/* )} */}

      <Dialog open={updateModal} onClose={handleUpdateModalClose}>
        <DialogTitle id="alert-dialog-title">
          Confirmation Update to {labelStatus}
        </DialogTitle>
        <DialogContent sx={{ width: 400 }}>
          {newStatusCandidate === 3 ? (
            <div className="form-row">
              <div className="col-md-12">
                <FormGroup>
                  <label style={{ fontSize: 14 }}>Tanggal Psikotest</label>
                  <Input
                    onChange={(e) => {
                      setSelectedPsikotestDate(e.target.value);
                    }}
                    type="date"
                    min={thisIsToday}
                  />
                </FormGroup>
                <FormGroup>
                  <label style={{ fontSize: 14 }}>Jam Psikotest</label>
                  <TextField
                    type="time"
                    onChange={(e) => setPsikotestTime(e.target.value)}
                    size="small"
                  />
                </FormGroup>
                <label style={{ fontSize: 14 }}>Tentukan Tahap Psikotest</label>

                <FormGroup>
                  <RadioGroup
                    row
                    sx={{ ml: 1 }}
                    onChange={(e) => {

                      if(e.target.value === "true"){
                        setTahapPsikotestCfit(true)
                        setTahapPsikotestPapikostik(false)
                      }else {
                        setTahapPsikotestPapikostik(true)
                        setTahapPsikotestCfit(false)
                      }
                      
                    }}
                    defaultValue={true}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="CFIT"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="Papikostik"
                    />
                  </RadioGroup>
                </FormGroup>

                {/* <div className="form-row">
                  <div className="col-md-2" style={{ marginLeft: 10 }}>
                    <FormControlLabel
                      control={
                        <Checkbox onChange={(e) => handleSelectedCfit(e)} />
                      }
                      label="CFIT"
                    />
                  </div>
                  <div className="col-md-6">
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={(e) => handleSelectedPapikostik(e)}
                        />
                      }
                      label="Papikostik"
                    />
                  </div>
                </div> */}
                <FormGroup>
                  <label style={{ fontSize: 14 }}>Jenis Psikotest</label>
                  <RadioGroup
                    row
                    sx={{ ml: 1 }}
                    onChange={(e) => handleSelectedIntvIsOnline(e.target.value)}
                    defaultValue={true}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Online"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="Offline"
                    />
                  </RadioGroup>
                </FormGroup>
                <FormGroup>
                  {intvIsOnline === false ? (
                    <Select
                      placeholder="Tentukan Lokasi Interview"
                      options={optionsLokasiInterview}
                      isClearable
                      onChange={(e) => setLocationInterview(e.value)}
                    />
                  ) : (
                    <Input
                      placeholder="Lampirkan Link Psikotest"
                      onChange={(e) => setLinkInterview(e.target.value)}
                    />
                  )}
                </FormGroup>
              </div>
            </div>
          ) : newStatusCandidate === 4 ? (
            <div className="form-row">
              <div className="col-md-12">
                <FormGroup>
                  <label style={{ fontSize: 14 }}>
                    Pilih Tanggal Interview HR
                  </label>
                  <Input
                    type="date"
                    onChange={(e) => setInterviewDate(e.target.value)}
                    min={thisIsToday}
                  />
                </FormGroup>
                <FormGroup>
                  <label style={{ fontSize: 14 }}>Jam Interview</label>
                  <TextField
                    type="time"
                    onChange={(e) => setInterviewTime(e.target.value)}
                    size="small"
                  />
                </FormGroup>
                <FormGroup>
                  <label style={{ fontSize: 14 }}>Jenis Interview</label>
                  <RadioGroup
                    row
                    sx={{ ml: 1 }}
                    onChange={(e) => handleSelectedIntvIsOnline(e.target.value)}
                    defaultValue={true}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Online"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="Offline"
                    />
                  </RadioGroup>
                </FormGroup>

                <FormGroup>
                  {intvIsOnline === false ? (
                    <Select
                      placeholder="Tentukan Lokasi Interview"
                      options={optionsLokasiInterview}
                      isClearable
                      onChange={(e) => setLocationInterview(e.value)}
                    />
                  ) : (
                    <Input
                      placeholder="Lampirkan Link Interview"
                      onChange={(e) => setLinkInterview(e.target.value)}
                    />
                  )}
                </FormGroup>
              </div>
            </div>
          ) : newStatusCandidate === 5 ? (
            <div className="form-row">
              <div className="col-md-12">
                <FormGroup>
                  <label style={{ fontSize: 14 }}>
                    Pilih Tanggal Interview User
                  </label>
                  <Input
                    type="date"
                    onChange={(e) => setInterviewDate(e.target.value)}
                    min={thisIsToday}
                  />
                </FormGroup>
                <FormGroup>
                  <label style={{ fontSize: 14 }}>Jam Interview User</label>
                  <TextField
                    type="time"
                    onChange={(e) => setInterviewTime(e.target.value)}
                    size="small"
                  />
                </FormGroup>
                <FormGroup>
                  <label style={{ fontSize: 14 }}>Jenis Interview</label>
                  <RadioGroup
                    row
                    sx={{ ml: 1 }}
                    onChange={(e) => handleSelectedIntvIsOnline(e.target.value)}
                    defaultValue={true}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Online"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="Offline"
                    />
                  </RadioGroup>
                </FormGroup>
                <FormGroup>
                  {intvIsOnline === false ? (
                    <Select
                      placeholder="Tentukan Lokasi Interview"
                      options={optionsLokasiInterview}
                      isClearable
                      onChange={(e) => setLocationInterview(e.value)}
                    />
                  ) : (
                    <Input
                      placeholder="Lampirkan Link Interview"
                      onChange={(e) => setLinkInterview(e.target.value)}
                    />
                  )}
                </FormGroup>
              </div>
            </div>
          ) : newStatusCandidate === 6 ? (
            <>
              <div className="form-row">
                <div className="col-md-12">
                  <FormGroup>
                    <label style={{ fontSize: 14 }}>
                      Pilih Deadline Pengumpulan
                    </label>
                    <Input
                      type="date"
                      onChange={(e) => setTestDate(e.target.value)}
                      min={thisIsToday}
                    />
                  </FormGroup>
                  <FormGroup>
                    <label style={{ fontSize: 14 }}>
                      Batas Waktu Pengumpulan
                    </label>
                    <TextField
                      type="time"
                      onChange={(e) => setTestTime(e.target.value)}
                      size="small"
                    />
                  </FormGroup>
                  <FormGroup>
                    <label style={{ fontSize: 14 }}>Format file</label>
                    <RadioGroup
                      row
                      sx={{ ml: 1 }}
                      onChange={(e) => handleSelectedFormat(e.target.value)}
                      defaultValue={true}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="File"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio />}
                        label="Link Google Drive"
                      />
                    </RadioGroup>
                  </FormGroup>
                  <FormGroup>
                    {fileFormat === false ? (
                      <>
                        <label style={{ fontSize: 14 }}>
                          Link Google Drive
                        </label>
                        <Input
                          placeholder="Lampirkan link Google Drive"
                          onChange={(e) => setLinkDrive(e.target.value)}
                        />
                      </>
                    ) : (
                      <>
                        <label style={{ fontSize: 14 }}>Lampiran File</label>
                        <Dropzone
                          accept=".pdf,.docx,.xlsx"
                          middleText={
                            uploadFile.length > 0
                              ? uploadFile
                              : "Click or Drag File Here"
                          }
                          bottomText="File must be PDF/DOCX/XLSX"
                          onChange={(files) => handleFile(files[0])}
                        // onInvalid={(i) => toastError("Error: " + i)}
                        />
                      </>
                    )}
                  </FormGroup>
                </div>
              </div>
            </>
          ) : newStatusCandidate === 8 ? (
            <React.Fragment>
              <div className="form-row">
                <div className="col-md-12">
                  <FormGroup>
                    <label style={{ fontSize: 14 }}>Pilih Tanggal MCU</label>
                    <Input
                      type="date"
                      onChange={(e) => setMcuDate(e.target.value)}
                      min={thisIsToday}
                    />
                  </FormGroup>
                  <FormGroup>
                    <label style={{ fontSize: 14 }}>Jam MCU</label>
                    <TextField
                      type="time"
                      onChange={(e) => setMcuTime(e.target.value)}
                      size="small"
                    />
                  </FormGroup>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12">
                  <FormGroup>
                    <label style={{ fontSize: 14 }}>Pilih Lokasi MCU</label>
                    <Select
                      placeholder="Lokasi Mcu"
                      options={optionsLokasiMCU}
                      onChange={(e) => setMcuLocation(e.value)}
                      isClearable
                    />
                  </FormGroup>
                </div>
                {/* <Button onClick={onTestPdf}>onTestPdf</Button> */}
              </div>
            </React.Fragment>
          ) : newStatusCandidate === 10 ? (
            <React.Fragment>
              <div className="form-row">
                <div className="col-md-12">
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) => handleCheckBlacklist(e.target.checked)}
                      />
                    }
                    label="Blacklist Candidate?"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12">
                  {visibleBlacklistReason === true ? (
                    <FormGroup>
                      <Input
                        type="text"
                        onChange={(e) =>
                          setValueBlacklistReason(e.target.value)
                        }
                        placeholder="Entry Blacklist Reason"
                      />
                    </FormGroup>
                  ) : null}
                </div>
              </div>
            </React.Fragment>
          ) : (
            <p>Do you really want update candidate status?</p>
          )}
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={handleUpdateModalClose}>
            Cancel
          </Button>
          <Button
            onClick={
              newStatusCandidate === 3
                ? submitAssignPsikotest
                : newStatusCandidate === 4
                  ? submitAssignInterviewCandidate
                  : newStatusCandidate === 5
                    ? submitAssignInterviewCandidate
                    : newStatusCandidate === 6
                      ? submitAssignTechnicalTest
                      : newStatusCandidate === 8
                        ? submitAssignMCU
                        : newStatusCandidate === 10
                          ? submitBlacklistMerge
                          : submitUpdateStatusCandidate

                    
            }
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default CandidatesByStatus;
